import clsx from 'clsx';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import Avatar from '../../../base/avatar/components/Avatar';
import ChatMessage from './ChatMessage';
import { useSelector } from 'react-redux';
import { getSenderByUserId } from '../../../vtchat-moderation/functions';
import { MESSAGE_TYPE_REMOTE } from '../../constants';
import { Tooltip } from '@mui/material';
const useStyles = makeStyles()(theme => {
    return {
        messageGroup: {
            display: 'flex',
            flexDirection: 'column',
            maxWidth: '100%',
            '&.remote': {
                maxWidth: 'calc(100% - 40px)' // 100% - avatar and margin
            }
        },
        groupContainer: {
            display: 'flex',
            '&.local': {
                justifyContent: 'flex-end',
                '& .avatar': {
                    display: 'none'
                }
            }
        },
        avatar: {
            margin: `${theme.spacing(1)} ${theme.spacing(2)} ${theme.spacing(3)} 0`,
            position: 'sticky',
            flexShrink: 0,
            top: 0
        }
    };
});
const ChatMessageGroup = ({ className = '', messages, dispatch }) => {
    const { classes } = useStyles();
    const messagesLength = messages.length;
    if (!messagesLength) {
        return null;
    }
    const latest = messages[messagesLength - 1];
    const senderInfo = useSelector((state) => getSenderByUserId(`${latest.senderAccId}`, state));
    return (React.createElement("div", { className: clsx(classes.groupContainer, className, 'chat-message-group-container') },
        className === MESSAGE_TYPE_REMOTE && (React.createElement("div", { className: "chat-message-group-avatar" },
            React.createElement(Tooltip, { title: latest?.senderAccName, placement: "top" },
                React.createElement("div", null, senderInfo ? (React.createElement(Avatar, { displayName: latest.senderAccName, size: 25, avatarUrl: latest.senderAvatar || senderInfo.senderAvatar })) : (React.createElement(Avatar, { className: clsx(classes.avatar, 'avatar'), participantId: messages[0].participantId, size: 32 })))))),
        React.createElement("div", { className: `${classes.messageGroup} chat-message-group ${className}` }, messages.map((message, i) => (React.createElement(ChatMessage, { key: i, message: message, showDisplayName: i === 0, showTimestamp: i === messages.length - 1, indexClass: i === 0 ? 'first' : i === messagesLength - 1 ? 'last' : '', dispatch: dispatch, type: className, displayName: latest.senderAccName || senderInfo?.senderAccName || null }))))));
};
export default ChatMessageGroup;
